import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AddressEditComponent } from 'app/common/address/address-edit.component';
import * as MasterDataActions from "../../../store/actions/masterdata.action";
import * as MasterDataSelectors from "../../../store/selectors/masterdata.selector";
import * as GeneralActions from "../../../store/actions/general.action";
import * as GeneralSelectors from "../../../store/selectors/general.selector";
import * as SupplierTasksActions from "../../../store/actions/supplier-task.action";
import * as SupplierTasksSelectors from "../../../store/selectors/supplier-tasks.selector";
import { OnboardingState } from 'app/profile/store/state/onboarding.state';
import { Store } from '@ngrx/store';
import { AddressType, Country } from 'app/profile/models/masterdata.model';
import { Observable, of } from 'rxjs';
import { GeneralSettings } from 'app/profile/models/generic.model';
import { ContextVerbiage, OPERATION, SupplierAddress } from 'app/profile/models/supplier.model';
import { OnboardingAddressDetails, OnboardingDocument, OnboardingTab, TaskStatus } from 'app/profile/models/onboarding.model';
import { ActivatedRoute, Router } from '@angular/router';
import { SupplierTaskService } from 'app/profile/services/supplier-task.service';
import { SupplierTasksState } from 'app/profile/store/state/supplier-tasks.state';
import { FileViewerComponent } from 'app/shared/components/file-viewer/file-viewer.component';
import { TslDialog, TslToastrService } from '@tesla/ng-tds';
import { MatDialog } from '@angular/material/dialog';
import { SupplierStateService } from 'app/profile/services/supplierstate.service';
import * as LoaderActions from "../../../../shared/store/actions/loader.actions";
import { AddressSuggestionComponent } from 'app/shared/components/address-suggestion/address-suggestion.component';
import { SupplierTaskEntityMapping, SupplierTaskEntityMappingOption, SupplierTaskResponse, SupplierTaskStep, SupplierTaskTableCol, SupplierTaskTableMasterData } from '../../../models/suppliertasks.model';
import * as OnboardingActions from '../../../store/actions/onboarding.actions';
import { I18nService } from 'app/shared/services/i18n.service';
import { cloneDeep } from "lodash";
import { AddressTaskDialogComponent } from './address-task-dialog/address-task-dialog.component';
import { ExistSelectComponent } from '../exist-select/exist-select.component';
import { EntityMappingComponent } from '../entity-mapping/entity-mapping.component';

@Component({
  selector: 'app-address-task-wrapper',
  templateUrl: './address-task-wrapper.component.html',
  styleUrls: ['./address-task-wrapper.component.scss']
})
export class AddressTaskWrapperComponent implements OnInit {
  onboardingTab: OnboardingTab = OnboardingTab.ADDRESS;
  countries: Country[];
  addressTypes$: Observable<AddressType[]>;
  settings$: Observable<GeneralSettings>;
  supplierAddressType: string;
  contextVerbiage: ContextVerbiage;
  requiredDocuments: OnboardingDocument[] = [];
  supplierCode: string = null;
  taskId: number;
  isLoaded: boolean = false;
  supplierAddress: SupplierAddress = new SupplierAddress();
  supplierAddressList: SupplierAddress[];
  taskStatus: string;
  rejectionDetails: any;
  selectedIndex: number;
  existingItemList: SupplierAddress[];
  displayedColumns: SupplierTaskTableCol[] = [];
  tableData: SupplierTaskTableMasterData;
  isValidSelectTable: boolean = true;
  isCreateNew: boolean = false;
  taskInfo: SupplierTaskStep;
  requestType: string;
  selectedIndexList: number[] = [];

  unSelectedIndexList: number[] = [];
  tableErrorMessage: string;
  entityMappings: SupplierTaskEntityMapping[] = [];
  entityMappingOptions: SupplierTaskEntityMappingOption[] = [];
  /** Current supplier code in the onboarding process */
  @Input('tsl-hideContactDocumentSection')
  hideContactDocumentSection: boolean = false;

  //  Take a reference of the address edit component to invoke the submit action
  @ViewChild('addressEdit', { static: false }) addressEditComponent: AddressEditComponent;
  @ViewChild('selectTable', { static: false }) selectTableComponent: ExistSelectComponent;
  @ViewChild('entityMapping', { static: false }) entityMappingComponent: EntityMappingComponent;

  @Input('supplierCode') set _supplierCode(val: string) { if (val && val.trim() != "") this.supplierCode = val; };
  @Input('taskId') set _taskId(val: number) { if (val) this.taskId = val; };
  @Input('isSidePanelMode') isSidePanelMode: boolean = false;
  @Input() isReactivation: boolean = false;
  @Input() enableExistSelection: boolean = false;
  @Output() onSave: EventEmitter<boolean> = new EventEmitter<boolean>();
  
  constructor(private onboardingStore: Store<OnboardingState>,
    private route: ActivatedRoute,
    private matDialog: MatDialog,
    private tasksStore: Store<SupplierTasksState>,
    private supplierStateService: SupplierStateService,
    private tslDialog: TslDialog,
    private taskService: SupplierTaskService,
    private toaster: TslToastrService,
    private router: Router,
    private translate: I18nService,
  ) { }

  ngOnInit(): void {
    this.route?.parent?.params?.subscribe(params => {
      if (params?.code && params?.portalTaskId) {
        this.supplierCode = params.code;
        this.taskId = params.portalTaskId;
      }
    });

    //  Dispatch actions to get list of countries
    this.onboardingStore.dispatch(new MasterDataActions.GetCountryList());
    // this.tasksStore.dispatch(new SupplierTasksActions.GetTaskStepState(this.supplierCode, this.taskId, this.onboardingTab, true));

    //  Use selector to query countries
    this.onboardingStore.select(MasterDataSelectors.SelectCountries).subscribe(countries => this.countries = countries);
    this.onboardingStore.select(MasterDataSelectors.SelectContextVerbiage).subscribe(contextVerbiage => this.contextVerbiage = contextVerbiage);

    // get task details by task type. 
    this.taskService.getSupplierTaskStep(this.supplierCode, this.taskId, this.onboardingTab).subscribe(taskInfo => {
      if (taskInfo && taskInfo.taskConfiguration) {
        this.taskInfo = taskInfo;
        this.requestType = this.taskInfo?.taskConfiguration?.SupplierRequestType;
        if(this.requestType) this.requestType = this.requestType[0].toLocaleLowerCase() + this.requestType.substring(1);
        this.supplierAddressType = taskInfo.taskConfiguration.SupplierAddressType;
        this.requiredDocuments = taskInfo.taskConfiguration?.Documents;
        this.hideContactDocumentSection = this.requiredDocuments?.length > 0;
        this.taskStatus = taskInfo.taskStatus;
        this.rejectionDetails = taskInfo?.rejectionDetails;
        if (this.taskStatus != TaskStatus.Completed && taskInfo.portalTaskResponse != null) {
          if(["nameOrTINChange"].includes(this.requestType)) {
            if(!taskInfo.portalTaskResponse.length) this.supplierAddressList = [taskInfo.portalTaskResponse];
            else this.supplierAddressList = taskInfo.portalTaskResponse.filter(x => x.operation != OPERATION.DELETE);
          } else this.supplierAddress = taskInfo.portalTaskResponse;
        }

        if(this.isReactivation || this.enableExistSelection || ["nameOrTINChange"].includes(this.requestType)) {
          // use supplier code and based on type to grab item list
          this.supplierStateService.getAddressListByCode(this.supplierCode).subscribe(resList => {
            this.existingItemList = resList?.map(x => ({
              Operation: x?.operation?.newValue,
              ID: x?.id?.newValue,
              StageID: x?.stageID?.newValue,
              Types: x?.types?.newValue,
              Street1: x?.street1?.newValue,
              Street2: x?.street2?.newValue,
              Street3: x?.street3?.newValue,
              City: x?.city?.newValue,
              State: x?.state?.newValue,
              CountryCode: x?.countryCode?.newValue,
              ZipCode: x?.zipCode?.newValue,
              Comment: x?.comment?.newValue,
              Documents: x?.documents?.newValue,
              DocumentInfos: null,
            }));
            this.initTableData();
            if(["nameOrTINChange"].includes(this.requestType)) {
              this.supplierStateService.getEntityMappingByCodeAndTaskType(this.supplierCode, "AddressList").subscribe(res => {
                if(this.supplierAddressList?.length) {
                  res?.forEach(x => {
                    x.taskItem = this.existingItemList.find(y => y.EntityCountryIDList?.includes(x.entityCountryID))?.ID;
                  });
                }
                this.entityMappings = res;
                setTimeout(() => {
                  this.initEntityMappingOptionData();
                }, 0);
              });
            }
          })
        } else this.isLoaded = true;
      }
    });
  }

  initTableData() {
    this.displayedColumns = [{propertyName: "address", title: "Remittance Address"}];
    if(["nameOrTINChange"].includes(this.requestType)) {
      let existIndexList = [];
      if(!this.unSelectedIndexList) this.unSelectedIndexList = [];
      this.supplierAddressList?.forEach(address => {
        if(address) {
          let existIndex = this.existingItemList?.findIndex(x => x.ID == address.ID && address.ID != 0);
          if(existIndex < 0) {
            if(!this.existingItemList.length) this.existingItemList = [];
            address.Operation = OPERATION.CREATE;
            address.ID = Math.floor(1000000 + Math.random() * 9000000);
            existIndexList.push(this.existingItemList.push(cloneDeep(address)) - 1);
          } else {
            this.existingItemList[existIndex] = cloneDeep(address);
            if(address.Operation !== OPERATION.DELETE) existIndexList.push(existIndex)
          }
        }
      });
      let selectHeader = "Please confirm if this information is still active.";
      this.tableData = {
        supplierCode: this.supplierCode,
        onboardingTab: this.onboardingTab,
        selectHeader: selectHeader,
        countryName: this.taskInfo?.taskConfiguration?.EntityCountry,
        disableCreateNew: false,
        enableFirstEdit: true,
        disableEdit: false,
        enableMultiSelect: true,
        enablePrimarySelect: false,
        enableDocumentUpload: false,
        showMessage: true,
        enableAddNew: true,
        displayTitle: false,
        createNewLabel: "ADD NEW ADDRESS DETAILS",
        data: this.existingItemList?.map((x, index) => {
          let obj = {
            address: `${x.Street1}${x.Street2? ", " + x.Street2: ""}${x.Street3? ", " + x.Street3: ""}${x.City? ", " + x.City: ""}${x.State? ", " + x.State: ""}${x.CountryCode? ", " + x.CountryCode: ""}`,
            value: x.ID,
            isNew: x.Operation == OPERATION.CREATE
          };
          if(existIndexList?.includes(index)) {
            obj["isSelected"] = true;
            this.isValidSelectTable = true;
            if(!this.selectedIndexList) this.selectedIndexList = [];
            this.selectedIndexList.push(index);
          } else if(existIndexList?.length || (!!(this.supplierAddressList?.length  && !existIndexList?.length))) {
            obj["isSelected"] = false;
            this.unSelectedIndexList.push(index);
          }
          return obj;
        })
      };
    } else {
      if(!this.existingItemList?.length) {
        this.isValidSelectTable = true;
        this.isCreateNew = true;
      }
      let existIndex;
      if(this.supplierAddress?.ID > -1) {
        existIndex = this.existingItemList?.findIndex(x => x.ID == this.supplierAddress.ID);
        if(existIndex < 0) {
          this.selectedIndex = this.existingItemList? this.existingItemList.length : null;
          this.isValidSelectTable = true;
          this.isCreateNew = true;
        } else {
          this.existingItemList[existIndex] = cloneDeep(this.supplierAddress);
        }
      }
  
      let selectHeader;
      if(this.requestType == "entityExtension") selectHeader = "Please confirm if this information can be used to conduct business with the listed Tesla location or add new details.";
      else selectHeader = "Please confirm if this information is still active.";
  
      this.tableData = {
        supplierCode: this.supplierCode,
        onboardingTab: this.onboardingTab,
        selectHeader: selectHeader,
        countryName: this.taskInfo?.taskConfiguration?.EntityCountry,
        disableCreateNew: false,
        enableFirstEdit: true,
        disableEdit: false,
        showMessage: this.isReactivation,
        displayTitle: true,
        isNewSelected: !!(this.supplierAddress?.ID > -1 && existIndex < 0),
        data: this.existingItemList?.map((x, index) => {
          let obj = {
            address: `${x.Street1}${x.Street2? ", " + x.Street2: ""}${x.Street3? ", " + x.Street3: ""}${x.City? ", " + x.City: ""}${x.State? ", " + x.State: ""}${x.CountryCode? ", " + x.CountryCode: ""}`,
            value: x.ID
          };
          if(index == existIndex) {
            obj["isSelected"] = true;
            this.isValidSelectTable = true;
            this.selectedIndex = index;
          } else if(existIndex > -1 || (!!(this.supplierAddress?.ID > -1 && existIndex < 0))) obj["isSelected"] = false;
          return obj;
        })
      };
    }
    this.isLoaded = true;
  }

  initEntityMappingOptionData() {
    this.entityMappingOptions = this.existingItemList?.filter((x, index) => this.selectedIndexList?.includes(index))?.map(x => {
      return {
        displayName: `${x.Street1}${x.Street2? ", " + x.Street2: ""}${x.Street3? ", " + x.Street3: ""}${x.City? ", " + x.City: ""}${x.State? ", " + x.State: ""}${x.CountryCode? ", " + x.CountryCode: ""}`,
        value: x.ID
      }
    })
  }

  isSameAddress(a: SupplierAddress, b: SupplierAddress): boolean {
    let flag = true
    flag = flag && (a.Street1?.toLowerCase()?.trim() || "") == (b.Street1?.toLowerCase()?.trim() || "");
    flag = flag && (a.Street2?.toLowerCase()?.trim() || "") == (b.Street2?.toLowerCase()?.trim() || "");
    flag = flag && (a.Street3?.toLowerCase()?.trim() || "") == (b.Street3?.toLowerCase()?.trim() || "");
    flag = flag && (a.City?.toLowerCase()?.trim() || "") == (b.City?.toLowerCase()?.trim() || "");
    flag = flag && (a.State?.toLowerCase()?.trim() || "") == (b.State?.toLowerCase()?.trim() || "");
    flag = flag && (a.CountryCode?.toLowerCase()?.trim() || "") == (b.CountryCode?.toLowerCase()?.trim() || "");
    flag = flag && (a.ZipCode?.toLowerCase()?.trim() || "") == (b.ZipCode?.toLowerCase()?.trim() || "");
    flag = flag && (a.Comment?.toLowerCase()?.trim() || "") == (b.Comment?.toLowerCase()?.trim() || "");
    flag = flag && (a.Documents?.join(",")?.toLowerCase()?.trim() || "") == (b.Documents?.join(",")?.toLowerCase()?.trim() || "");
    return flag;
  }

  onSelected(index) {
    this.isValidSelectTable = true;
    if(["nameOrTINChange"].includes(this.requestType)) {
      if(!this.selectedIndexList) this.selectedIndexList = [];
      if(!this.unSelectedIndexList) this.unSelectedIndexList = [];
      if(index < 0) {
        if(this.selectedIndexList.includes(-(index + 1))) {
          index = -(index + 1);
          this.selectedIndexList.splice(this.selectedIndexList.indexOf(index), 1);
          this.unSelectedIndexList.push(index);
          this.initEntityMappingOptionData();
        } else this.unSelectedIndexList.push(-(index + 1));
      } else {  
        if(this.selectedIndexList.includes(this.existingItemList?.length)) {
          this.selectedIndexList.splice(this.selectedIndexList.indexOf(this.existingItemList?.length), 1);
          this.initEntityMappingOptionData();
        }
        this.selectedIndexList.push(index);
        if(this.unSelectedIndexList.includes(index)) this.unSelectedIndexList.splice(this.unSelectedIndexList.indexOf(index), 1);
      }
    } else {
      this.selectedIndex = index;
      this.isValidSelectTable = true;
      if(this.selectedIndex >= this.existingItemList?.length) {
        this.isCreateNew = true;
        this.supplierAddress = new SupplierAddress();
      }
      else this.isCreateNew = false;
    }
  }

  onEdit(event) {
    let index = event?.index;
    if (index < this.existingItemList?.length) {
      let requiredDoc = cloneDeep(this.requiredDocuments);
      let supplierAddress = cloneDeep(this.existingItemList[index]);
      if (supplierAddress!=undefined && supplierAddress.DocumentInfos!=undefined && supplierAddress.DocumentInfos?.length > 0) { 
        requiredDoc = supplierAddress.DocumentInfos;
      }
      const dialogRef = this.matDialog.open(AddressTaskDialogComponent,
        { 
          width: '1200px', 
          maxHeight: '80vh',
          autoFocus: false,
          data: { 
            supplierCode: this.supplierCode, 
            requiredDocuments: requiredDoc,
            supplierAddress: supplierAddress,
            addressTypes$: this.addressTypes$,
            countries: this.countries,
            supplierAddressType: this.supplierAddressType,
            settings$: this.settings$,
            hideContactDocumentSection: this.hideContactDocumentSection,
            isReactivation: this.isReactivation || this.enableExistSelection
          } 
        }
      );
      dialogRef.afterClosed().subscribe(res => {
        if(res) {
          res.ID = this.existingItemList[index].ID;
          res.Operation = this.existingItemList[index]?.Operation;
          this.existingItemList[index] = res;
          if(["nameOrTINChange"].includes(this.requestType)) {
            this.reloadTableData();
            this.initEntityMappingOptionData();
          } else {
            this.selectTableComponent?.updateTableData(this.existingItemList?.map((x, i) => {
              let obj = {
                address: `${x.Street1}${x.Street2? ", " + x.Street2: ""}${x.Street3? ", " + x.Street3: ""}${x.City? ", " + x.City: ""}${x.State? ", " + x.State: ""}${x.CountryCode? ", " + x.CountryCode: ""}`,
                value: x.ID
              };
              if(index == i) {
                obj["isSelected"] = true;
                this.isValidSelectTable = true;
              }
              return obj;
            }), false);
          }
        } else {
          if(event?.isFirstTime) {
            this.selectTableComponent?.onSelectSwitch(null, index, false);
          }
        }
      })
    }
  }

  onView(event) {
    let index = event?.index;
    if (index < this.existingItemList?.length) {
      let requiredDoc = cloneDeep(this.requiredDocuments);
      let supplierAddress = cloneDeep(this.existingItemList[index]);
      if (supplierAddress!=undefined && supplierAddress.DocumentInfos!=undefined && supplierAddress.DocumentInfos?.length > 0) { 
        requiredDoc = supplierAddress.DocumentInfos;
      }
      const dialogRef = this.matDialog.open(AddressTaskDialogComponent,
        { 
          width: '1200px', 
          maxHeight: '80vh',
          autoFocus: false,
          data: { 
            supplierCode: this.supplierCode, 
            requiredDocuments: requiredDoc,
            supplierAddress: supplierAddress,
            addressTypes$: this.addressTypes$,
            countries: this.countries,
            supplierAddressType: this.supplierAddressType,
            settings$: this.settings$,
            readOnly: true,
            hideContactDocumentSection: this.hideContactDocumentSection,
            isReactivation: this.isReactivation || this.enableExistSelection
          } 
        }
      );
    }
  }

  onAdd() {
    let requiredDoc = cloneDeep(this.requiredDocuments);
    const dialogRef = this.matDialog.open(AddressTaskDialogComponent,
      { 
        width: '1200px', 
        maxHeight: '80vh',
        autoFocus: false,
        data: { 
          supplierCode: this.supplierCode, 
          requiredDocuments: requiredDoc,
          addressTypes$: this.addressTypes$,
          countries: this.countries,
          supplierAddressType: this.supplierAddressType,
          settings$: this.settings$,
          hideContactDocumentSection: this.hideContactDocumentSection,
          isReactivation: this.isReactivation || this.enableExistSelection
        } 
      }
    );
    dialogRef.afterClosed().subscribe(res => {
      if(res) {
        res.Operation = OPERATION.CREATE;
        res.ID = Math.floor(1000000 + Math.random() * 9000000);
        this.selectedIndexList.push(this.existingItemList.push(cloneDeep(res)) - 1);
        this.reloadTableData();
        this.initEntityMappingOptionData();
      }
    });
  }

  onDelete(event) {
    let index = event?.index;
    this.selectedIndexList.splice(this.selectedIndexList.indexOf(index), 1);
    this.existingItemList.splice(index, 1);
    this.reloadTableData();
    this.initEntityMappingOptionData();
  }

  reloadTableData() {
    this.selectTableComponent?.updateTableData(this.existingItemList?.map((x, index) => {
      let obj = {
        address: `${x.Street1}${x.Street2? ", " + x.Street2: ""}${x.Street3? ", " + x.Street3: ""}${x.City? ", " + x.City: ""}${x.State? ", " + x.State: ""}${x.CountryCode? ", " + x.CountryCode: ""}`,
        value: x.ID,
        isNew: x.Operation == OPERATION.CREATE
      };
      if(this.selectedIndexList?.includes(index)) {
        obj["isSelected"] = true;
        this.isValidSelectTable = true;
      } else {
        if(["nameOrTINChange"].includes(this.requestType)) {
          if(this.unSelectedIndexList?.includes(index)) obj["isSelected"] = false;
        } else if(this.selectedIndexList?.length || (!!(this.supplierAddressList?.length  && !this.selectedIndexList?.length))) obj["isSelected"] = false;
      }
      return obj;
    }), !["nameOrTINChange"].includes(this.requestType));
  }

  onSubmit() {
    if(["nameOrTINChange"].includes(this.requestType)) {
      if(!this.selectedIndexList?.length) {
        this.isValidSelectTable = false; 
        this.tableErrorMessage = "Proposed Value: Please confirm at least one active address above or add new information."
        return;
      }
      if(this.selectedIndexList?.length + this.unSelectedIndexList?.length != this.existingItemList?.length) {
        this.isValidSelectTable = false; 
        this.tableErrorMessage = "Please make decision for all items."
        return;
      }
      let entityMapping = this.entityMappingComponent?.onSubmit();
      if(!entityMapping?.length) return;
      let submitList = this.existingItemList.map((item, index) => {
        if(this.selectedIndexList.findIndex(x => x == index) < 0) item.Operation = OPERATION.DELETE;
        else {
          item.EntityCountryIDList = entityMapping.filter(x => x.taskItem == item.ID)?.map(x => x.entityCountryID);
          if(item.Operation != OPERATION.CREATE) item.Operation = OPERATION.UPDATE;
          else delete item.ID;
          if(item.DocumentInfos?.length) {
            if(!item.DocumentInfos[0].DocumentID || !item.DocumentInfos[0].FileName) {
              item.DocumentInfos = [];
              item.Documents = [];
            }
          }
        }
        return item;
      });
      this.postInformation(null, submitList);
    } else {
      if(this.isReactivation || this.enableExistSelection) {
        if(this.existingItemList?.length && !this.selectedIndex && this.selectedIndex !=0) {
          this.isValidSelectTable = false; 
          return;
        }
        if(this.selectedIndex < this.existingItemList?.length) {
          this.addressFormSubmit(this.existingItemList[this.selectedIndex]);
          return;
        }
      }
      this.addressEditComponent.submit();
    }
  }

  addressFormSubmit(supplierAddress: SupplierAddress) {
    if((this.isReactivation || this.enableExistSelection) && this.selectedIndex > -1 && this.selectedIndex < this.existingItemList?.length) {
      supplierAddress.ID = this.existingItemList[this.selectedIndex].ID;
      supplierAddress.Operation = OPERATION.UPDATE;
    }
    //  If country is US, we fetch address predictions
    if (supplierAddress.CountryCode == 'US') {
      this.supplierStateService.getPredictions(supplierAddress)

        //  1. Get address predictions and return the selected address if any
        .mergeMap(predictions => this.requestUserToSelectPrediction(predictions, supplierAddress))

        //  2. Use action to send POST request to save address
        .subscribe(address => {
          this.supplierAddress = address;
          //  Dispatch action to save the supplier address
          this.postInformation(address);
        });

    } else {
      //  We don't need to fetch address predictions
      this.postInformation(supplierAddress);
    }
  }

  postInformation(address: SupplierAddress, addresses?:SupplierAddress[]) {
    let body;
    if(addresses?.length) body = [...addresses]
    else body = { ...address };

    // if body is not empty then check for Document Info's for each address and mark FormGroup as Null
    // This step is required to resolve the circular dependency JSON stringify error
    if(body?.length > 0)
    {
      body.forEach(currAddress => {
        if(currAddress?.DocumentInfos?.length > 0)
        {
          currAddress?.DocumentInfos.forEach(x => {
            x.FormGroup = null;
          })
        }
      }); 
    }

    if(body?.DocumentInfos?.length > 0)
    {
      body?.DocumentInfos.forEach(x => {
        x.FormGroup = null;
      })
    }

    var response: SupplierTaskResponse = {
      id: this.taskId,
      supplierCode: this.supplierCode,
      taskResponseJson: JSON.stringify(body)
    }
    this.taskService.postSupplierTaskStepResponse(this.supplierCode, response).subscribe(res => {
      if (res) {
        this.toaster.success(this.translate.get('Submitted successfully!'));
        if (this.isSidePanelMode) this.onSave.emit(true);
        else this.router.navigate([`${this.supplierCode}`, "Onboarding", "Home"]);
      }
      else {
        this.toaster.error(this.translate.get('Something went wrong!'));
      }
    });
  }

  // manual
  showManual(manual) {
    this.matDialog.open(FileViewerComponent, {
      panelClass: ['sidepanel', 'animate__animated', 'animate__slideInRight'],
      width: '65%',
      height: '100%',
      minWidth: '630px',
      data: {
        fileName: manual.fileName,
        fileId: manual.fileId,
        fileVersion: manual.fileVersion
      }
    });
  }

  /** Opens dialog with address prections so that user can select one if required */
  private requestUserToSelectPrediction(predictions: any[], supplierAddress: SupplierAddress): Observable<SupplierAddress> {
    this.onboardingStore.dispatch(new LoaderActions.DecrementLoaderCount());    //  Hide spinner

    if (predictions && predictions.length > 0) {

      let completeAddress = supplierAddress.Street1 + ", " +
        supplierAddress.City + ", " +
        (supplierAddress.State ? supplierAddress.State : "") + " " +
        supplierAddress.ZipCode + ", " +
        this.countries.find(x => x.abbreviation === supplierAddress.CountryCode)?.name;

      if (predictions.findIndex(r => r === completeAddress) < 0) {

        //  The user entered an address that is not equal to any of the predictions,
        //  Open suggetion dialog to let the user select one of the predictions
        const dialogRef = this.tslDialog.open(AddressSuggestionComponent, {
          minWidth: '500px',
          data: predictions
        });

        //  Wait until the dialog is closed with the selected prediction
        return dialogRef.afterClosed().map((selectedAddress: SupplierAddress) => {

          //  Update the supplier address to have the data of the address
          //  that the user selected in the pop up dialog.
          if (selectedAddress) {
            supplierAddress = {
              ...supplierAddress,
              CountryCode: selectedAddress.CountryCode,
              Street1: selectedAddress.Street1,
              City: selectedAddress.City,
              State: selectedAddress.State,
              ZipCode: selectedAddress.ZipCode
            };
          }
          return supplierAddress;
        });
      } else {

        //  The Input Address is already in the collection of predictions,
        //  we dont' need the user to select a prediction.
        //  Use the address
        return of(supplierAddress);
      }
    } else {
      //  We don't have predictions for the input address
      //  Use the address as it is
      return of(supplierAddress);
    }
  }

  /** Sets error message at the onboarding store */
  setErrorMessage(errorMessage: string) {
    if (errorMessage) this.onboardingStore.dispatch(OnboardingActions.SetErrorMessage({ errorMessage }));
  }

  navigateToHome() {
    this.router.navigate([`${this.supplierCode}`, "Onboarding", "Home"]);
  }
}